import React from 'react';
import { Segment, Tab, Header, Grid, Icon, Popup, } from 'semantic-ui-react';
import axios from 'axios';

import Equivalence from './Equivalence/Equivalence';
import CandidateBasicInfo from './CandidateBasicInfo/CandidateBasicInfo';
import Status from './Status/Status';
import AddCourse from './AddCourse/AddCourse';
import { IconHeader } from '../../../../Assets/util/css';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class CandidateDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');

        element[0].childNodes[1].classList.remove('segment');
    }


    render() {
        const panes = [
            {
                menuItem: 'Osnovni podaci',
                render: () => <Tab.Pane ><CandidateBasicInfo /></Tab.Pane>,
            },
            localStorage.getItem('showAddButton') !== 'no' &&
            {
                menuItem: 'Dodavanje predmeta',
                render: () => <Tab.Pane attached={false}><AddCourse /></Tab.Pane>,
            },
            {
                menuItem: 'Predmeti',
                render: () => <Tab.Pane attached={false}><Equivalence /></Tab.Pane>,
            },

        ];
        return (
            <div>
                <h1> Detalji o kandidatu </h1>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    <Header style={IconHeader} floated="right">
                                        <Icon />
                                        <Popup
                                            trigger={<Icon
                                                link
                                                circular
                                                basic
                                                floated="right"
                                                name="arrow left"
                                                onClick={() => {
                                                    window.history.go(-1);
                                                }}
                                            />}
                                            content="Nazad"
                                            hideOnScroll
                                            position="top center"
                                        />
                                    </Header>
                                    {localStorage.getItem('candidateFirstName') + ' ' + localStorage.getItem('candidateLastName')}
                                </Header>
                            </Segment>
                            <Segment>

                                <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/CandidateDetails.js